<script>
  import { onMount } from "svelte";

  onMount(() => {
    window.location.href =
      "https://ihdev.s3.rbx.io.cloud.ovh.net/CV_HornerIvan_ihdev_2024-11-09.pdf";
  });
</script>
